import { render, staticRenderFns } from "./stock-summary.vue?vue&type=template&id=297718a2&scoped=true"
import script from "./stock-summary.vue?vue&type=script&lang=js"
export * from "./stock-summary.vue?vue&type=script&lang=js"
import style0 from "./stock-summary.vue?vue&type=style&index=0&id=297718a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297718a2",
  null
  
)

export default component.exports